import React, { useState, useEffect } from "react";
import "./reviewers.css";
import { ApiUrl } from "../../../../Admin/API/ApiUrl";
import { useQuery } from "@tanstack/react-query";

export default function Reviewers() {

  const fetchEditors = async () => {
    const response = await fetch(`${ApiUrl}/editorial-board`);
    const data = await response.json();

    if (!response.ok) {
      throw new Error("Failed to fetch editorial board");
    }

    const editorsArray = Array.isArray(data) ? data : data.data || [];

    // reverse here itself
    return [...editorsArray].reverse();
  };

  const {
    data: editorialBoard = [],
    isLoading,
    isError
  } = useQuery({
    queryKey: ["editorialBoard"],
    queryFn: fetchEditors,
    staleTime: 10 * 60 * 1000,
  });

  const executiveEditors = editorialBoard.filter(
    (editor) => editor.editor_type === "Executive Editors"
  );

  const nationalScientificBoard = editorialBoard.filter(
    (editor) => editor.editor_type === "National Scientific Board Member"
  );

  if (isLoading) return null;

  return (
    <div className="ijacna-reviewers-page">
      <header className="ijacna-reviewers-header">
        <h1 className="ijacna-reviewers-title">Editorial Board Members</h1>
        <p className="ijacna-reviewers-subtitle">
          Dedicated professionals contributing to the excellence of our journal.
        </p>
      </header>

      <section className="ijacna-reviewers-section">
        <h2 className="ijacna-reviewers-section-title">Executive Editors</h2>
        <div className="ijacna-reviewers-grid">
          {executiveEditors.map((editor, index) => (
            <div key={index} className="ijacna-reviewer-card">
              <div className="ijacna-reviewer-icon">🎓</div>
              <div className="ijacna-reviewer-info">
                <h3 className="ijacna-reviewer-name">{editor.name}</h3>
                {editor.qualification && (
                  <p className="ijacna-reviewer-qualification">
                    {editor.qualification}
                  </p>
                )}
                <p className="ijacna-reviewer-country">{editor.location}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="ijacna-reviewers-section">
        <h2 className="ijacna-reviewers-section-title">
          National Scientific Board Members
        </h2>
        <div className="ijacna-reviewers-grid">
          {nationalScientificBoard.map((member, index) => (
            <div key={index} className="ijacna-reviewer-card">
              <div className="ijacna-reviewer-icon">🌍</div>
              <div className="ijacna-reviewer-info">
                <h3 className="ijacna-reviewer-name">{member.name}</h3>
                {nationalScientificBoard.qualification && (
                  <p className="ijacna-reviewer-qualification">
                    {member.qualification}
                  </p>
                )}
                <p className="ijacna-reviewer-country">{member.location}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
